import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: '1rem'
  },
  fab: {
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  listItem: {
    width: '100%'
  }
}));
